module.exports = __webpack_public_path__ + "static/media/avatar.a44178fc.png";